import React from "react";
import Slider from "react-slick";
import { Typography } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PhotoCarousel = ({ photos }) => {
  if (!photos || photos.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        No photos available.
      </Typography>
    );
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <div className="custom-arrow next-arrow">Next</div>,
    prevArrow: <div className="custom-arrow prev-arrow">Prev</div>,
  };

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto" }}> {/* Constrain width and center */}
      <Slider {...settings}>
        {photos.map((photo, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px", // Fixed height
              width: "100%",
              backgroundColor: "#f0f0f0",
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            <img
              src={photo.photoURL}
              alt={`Slide ${idx + 1}`}
              style={{
                maxHeight: "100%",
                maxWidth: "100%",
                minWidth: "100%",
                objectFit: "contain",
                borderRadius: 8,
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default PhotoCarousel;